export const buildCategoryTree = (cats) => {
  const nodes = {};
  cats.forEach((c) => { nodes[c.id] = { ...c, children: [] }; });
  const roots = [];
  cats.forEach((c) => {
    const parent = c.parent_id && nodes[c.parent_id];
    (parent ? parent.children : roots).push(nodes[c.id]);
  });
  const sort = (arr) => { arr.sort((a, b) => a.name.localeCompare(b.name)); arr.forEach((n) => sort(n.children)); return arr; };
  return sort(roots);
};

export const subtreeIds = (node) => [node.id, ...node.children.flatMap(subtreeIds)];

export const ancestorIds = (cats, id) => {
  const byId = Object.fromEntries(cats.map((c) => [c.id, c]));
  const out = [];
  let cur = byId[id]?.parent_id;
  while (cur && byId[cur] && !out.includes(cur)) { out.push(cur); cur = byId[cur].parent_id; }
  return out;
};
